import {Component, OnInit, ViewChild} from '@angular/core';
import {ExcCoreModule} from 'exc-core';
import {ExcSigninService} from 'exc-signin';
import {ExcRestService} from 'exc-rest';

@Component({
  selector: 'app-order-create',
  templateUrl: './order-create.component.html',
  styles: []
})
export class OrderCreateComponent implements OnInit {
  surveyData: any = {
    locale: 'de',
    completedHtml: {
      de: '<finish>Vielen Dank für die Beauftragung. Eine Auftragsbestätigung erhalten Sie zeitnah per Mail. Bei Fragen wenden Sie sich bitte an unseren Service-Desk.<finish>'
    },
    pages: [
      {
        name: 'page1',
        elements: [
          {
            type: 'panel',
            name: 'panel5',
            elements: [
              {
                type: 'dropdown',
                name: 'auf_OE_ID',
                startWithNewLine: false,
                title: {
                  de: 'Mandant'
                },
                defaultValue: '633',
                isRequired: true,
                requiredErrorText: {
                  de: 'Bitte füllen Sie dieses Feld aus!'
                },
                readOnly: true,
                titleLocation: 'top',
                choices: [
                  {
                    value: '633',
                    text: {
                      de: 'Banque PSA Finance Niederlassung Österreich'
                    }
                  }
                ],
                optionsCaption: {
                  de: '-Bitte Auswählen-'
                }
              },
              {
                type: 'dropdown',
                name: 'mdtAnsprechpartnerId',
                startWithNewLine: false,
                title: {
                  de: 'Ansprechpartner'
                },
                isRequired: true,
                requiredErrorText: {
                  de: 'Bitte füllen Sie dieses Feld aus!'
                },
                titleLocation: 'top',
                choices: [
                  {
                    value: 'Burian, Werner',
                    text: 'Burian, Werner'
                  },
                  {
                    value: 'Dresler, Lothar-Philipp',
                    text: 'Dresler, Lothar-Philipp'
                  },
                  {
                    value: 'Kotalik, Susanne',
                    text: 'Kotalik, Susanne'
                  },
                  {
                    value: 'Krischek, Monika',
                    text: 'Krischek, Monika'
                  },
                  {
                    value: 'Legrand, Marie-Anne',
                    text: 'Legrand, Marie-Anne'
                  },
                  {
                    value: 'Mayer, Barbara',
                    text: 'Mayer, Barbara'
                  },
                  {
                    value: 'Schrefel, Tiffany',
                    text: 'Schrefel, Tiffany'
                  },
                  {
                    value: 'Schuh, Petra',
                    text: 'Schuh, Petra'
                  },
                  {
                    value: 'Zechner, Barbara',
                    text: 'Zechner, Barbara'
                  }
                ],
                optionsCaption: {
                  de: '-Bitte Auswählen-'
                }
              },
              {
                type: 'dropdown',
                name: 'aufZielID',
                title: {
                  default: 'Auftragsziel:',
                  de: 'Auftragsziel'
                },
                isRequired: true,
                requiredErrorText: {
                  de: 'Bitte füllen Sie dieses Feld aus!'
                },
                titleLocation: 'top',
                choices: [
                  'Forderungsausgleich',
                  'Sicherstellung',
                  'Forderungsausgleich oder Sicherstellung'
                ],
                optionsCaption: {
                  de: '-Bitte Auswählen-'
                }
              },
              {
                type: 'dropdown',
                name: 'aufArtID',
                startWithNewLine: false,
                title: {
                  default: 'Vertragsart:',
                  de: 'Vertragsart'
                },
                isRequired: true,
                requiredErrorText: {
                  de: 'Bitte füllen Sie dieses Feld aus!'
                },
                titleLocation: 'top',
                choices: [
                  'Kreditvertrag',
                  'Leasingvertrag'
                ],
                optionsCaption: {
                  de: '-Bitte Auswählen-'
                }
              },
              {
                type: 'text',
                name: 'aufVertragsnr',
                title: {
                  default: 'Vertragsnummer:',
                  de: 'Vertragsnummer'
                },
                isRequired: true,
                requiredErrorText: {
                  de: 'Bitte füllen Sie dieses Feld aus!'
                },
                titleLocation: 'top'
              },
              {
                type: 'text',
                name: 'aufVertragsdatum',
                startWithNewLine: false,
                title: {
                  de: 'Vertragsdatum'
                },
                isRequired: true,
                requiredErrorText: {
                  de: 'Bitte füllen Sie dieses Feld aus!'
                },
                validators: [
                  {
                    type: 'regex',
                    text: 'Bitte geben Sie ein gültiges Datum an!',
                    regex: '^(19|20){1}[0-9]{2}-.*'
                  }
                ],
                titleLocation: 'top',
                inputType: 'date'
              }
            ],
            title: {
              de: 'Auftragsrahmendaten'
            }
          },
          {
            type: 'panel',
            name: 'panelKundendate',
            elements: [
              {
                type: 'dropdown',
                name: 'aufKundeAnredeID',
                title: {
                  default: 'Anrede:',
                  de: 'Anrede'
                },
                isRequired: true,
                requiredErrorText: {
                  de: 'Bitte füllen Sie dieses Feld aus!'
                },
                titleLocation: 'top',
                choices: [
                  'Herr',
                  'Frau',
                  'Firma'
                ],
                optionsCaption: {
                  de: '-Bitte Auswählen-'
                }
              },
              {
                type: 'text',
                name: 'aufKundeName',
                startWithNewLine: false,
                title: {
                  default: 'Name:',
                  de: 'Name'
                },
                isRequired: true,
                requiredErrorText: {
                  de: 'Bitte füllen Sie dieses Feld aus!'
                },
                titleLocation: 'top'
              },
              {
                type: 'text',
                name: 'aufKundeVorname',
                visibleIf: '{aufKundeAnredeID} <> \'Firma\'',
                title: {
                  default: 'Vorname:',
                  de: 'Vorname'
                },
                titleLocation: 'top'
              },
              {
                type: 'text',
                name: 'aufKundeGeburtstag',
                visibleIf: '{aufKundeAnredeID} <> \'Firma\'',
                startWithNewLine: false,
                title: {
                  default: 'Geburtstag:',
                  de: 'Geburtsdatum'
                },
                validators: [
                  {
                    type: 'regex',
                    text: 'Bitte geben Sie ein gültiges Datum an!',
                    regex: '^(19|20){1}[0-9]{2}-.*'
                  }
                ],
                titleLocation: 'top',
                inputType: 'date'
              },
              {
                type: 'text',
                name: 'aufKundeStrasse',
                title: {
                  default: 'Strasse:',
                  de: 'Strasse'
                },
                isRequired: true,
                requiredErrorText: {
                  de: 'Bitte füllen Sie dieses Feld aus!'
                },
                titleLocation: 'top'
              },
              {
                type: 'text',
                name: 'aufKundePlz',
                startWithNewLine: false,
                title: {
                  default: 'Plz:',
                  de: 'Plz'
                },
                isRequired: true,
                requiredErrorText: {
                  de: 'Bitte füllen Sie dieses Feld aus!'
                },
                titleLocation: 'top'
              },
              {
                type: 'text',
                name: 'aufKundeOrt',
                title: {
                  default: 'Ort:',
                  de: 'Ort'
                },
                isRequired: true,
                requiredErrorText: {
                  de: 'Bitte füllen Sie dieses Feld aus!'
                },
                titleLocation: 'top'
              },
              {
                type: 'dropdown',
                name: 'aufKundeLkz',
                startWithNewLine: false,
                title: {
                  de: 'Land'
                },
                defaultValue: 'AT',
                isRequired: true,
                requiredErrorText: {
                  de: 'Bitte füllen Sie dieses Feld aus!'
                },
                titleLocation: 'top',
                choices: [
                  {
                    value: 'AL',
                    text: 'Albanien'
                  },
                  {
                    value: 'AD',
                    text: 'Andorra'
                  },
                  {
                    value: 'AO',
                    text: 'Angola'
                  },
                  {
                    value: 'BE',
                    text: 'Belgien'
                  },
                  {
                    value: 'BA',
                    text: 'Bosnien-Herzegowina'
                  },
                  {
                    value: 'BG',
                    text: 'Bulgarien'
                  },
                  {
                    value: 'DK',
                    text: 'Dänemark'
                  },
                  {
                    value: 'DE',
                    text: 'Deutschland'
                  },
                  {
                    value: 'EE',
                    text: 'Estland'
                  },
                  {
                    value: 'FI',
                    text: 'Finnland'
                  },
                  {
                    value: 'FR',
                    text: 'Frankreich'
                  },
                  {
                    value: 'GE',
                    text: 'Georgien'
                  },
                  {
                    value: 'GR',
                    text: 'Griechenland'
                  },
                  {
                    value: 'GB',
                    text: 'Großbritannien'
                  },
                  {
                    value: 'IE',
                    text: 'Irland'
                  },
                  {
                    value: 'IS',
                    text: 'Island'
                  },
                  {
                    value: 'IT',
                    text: 'Italien'
                  },
                  {
                    value: 'YU',
                    text: 'Jugoslawien'
                  },
                  {
                    value: 'HR',
                    text: 'Kroatien'
                  },
                  {
                    value: 'LV',
                    text: 'Litauen'
                  },
                  {
                    value: 'LU',
                    text: 'Luxemburg'
                  },
                  {
                    value: 'MT',
                    text: 'Malta'
                  },
                  {
                    value: 'MK',
                    text: 'Mazedonien'
                  },
                  {
                    value: 'MD',
                    text: 'Moldawien'
                  },
                  {
                    value: 'MC',
                    text: 'Monaco'
                  },
                  {
                    value: 'NL',
                    text: 'Niederlande'
                  },
                  {
                    value: 'NO',
                    text: 'Norwegen'
                  },
                  {
                    value: 'AT',
                    text: 'Österreich'
                  },
                  {
                    value: 'PL',
                    text: 'Polen'
                  },
                  {
                    value: 'PT',
                    text: 'Portugal'
                  },
                  {
                    value: 'RO',
                    text: 'Rumänien'
                  },
                  {
                    value: 'RU',
                    text: 'Russland '
                  },
                  {
                    value: 'SE',
                    text: 'Schweden'
                  },
                  {
                    value: 'CH',
                    text: 'Schweiz'
                  },
                  {
                    value: 'SK',
                    text: 'Slowakei'
                  },
                  {
                    value: 'SI',
                    text: 'Slowenien'
                  },
                  {
                    value: 'ES',
                    text: 'Spanien'
                  },
                  {
                    value: 'CZ',
                    text: 'Tschechische Rep.'
                  },
                  {
                    value: 'TR',
                    text: 'Türkei'
                  },
                  {
                    value: 'UA',
                    text: 'Ukraine'
                  },
                  {
                    value: 'HU',
                    text: 'Ungarn'
                  },
                  {
                    value: 'BY',
                    text: 'Weissrussland'
                  },
                  {
                    value: 'CY',
                    text: 'Zypern'
                  }
                ],
                optionsCaption: {
                  de: '-Bitte Auswählen-'
                }
              },
              {
                type: 'text',
                name: 'aufKundeTelefon',
                title: {
                  default: 'Telefon:',
                  de: 'Telefon'
                },
                titleLocation: 'top'
              },
              {
                type: 'text',
                name: 'aufKundeMobiltelefon',
                startWithNewLine: false,
                title: {
                  default: 'Mobiltelefon:',
                  de: 'Mobiltelefon'
                },
                titleLocation: 'top'
              },
              {
                type: 'text',
                name: 'aufKundeMail',
                startWithNewLine: false,
                title: {
                  de: 'E-Mail'
                },
                validators: [
                  {
                    type: 'email',
                    text: 'Bitte geben Sie eine gültige E-Mail Adresse an.'
                  }
                ],
                titleLocation: 'top',
                inputType: 'email'
              }
            ],
            title: 'Kundendaten',
            description: {
              de: 'Die Daten Ihres Vertragspartners'
            }
          },
          {
            type: 'panel',
            name: 'panel1',
            elements: [
              {
                type: 'dropdown',
                name: 'aufPersonTypID',
                title: {
                  de: 'Rolle'
                },
                titleLocation: 'top',
                choices: [
                  'Arbeitgeber',
                  'Bürge',
                  'Sonstige'
                ],
                optionsCaption: {
                  de: 'Welche Funktion übt die Person aus?'
                }
              },
              {
                type: 'dropdown',
                name: 'aufPersonAnredeID',
                visibleIf: '{aufPersonTypID} notempty',
                title: {
                  default: 'Anrede:',
                  de: 'Anrede'
                },
                isRequired: true,
                titleLocation: 'top',
                choices: [
                  'Herr',
                  'Frau',
                  'Firma'
                ],
                optionsCaption: {
                  de: '-Bitte Auswählen-'
                }
              },
              {
                type: 'text',
                name: 'aufPersonName',
                visibleIf: '{aufPersonTypID} notempty',
                startWithNewLine: false,
                title: {
                  default: 'Name:',
                  de: 'Name'
                },
                isRequired: true,
                titleLocation: 'top'
              },
              {
                type: 'text',
                name: 'aufPersonVorname',
                visibleIf: '{aufPersonAnredeID} <> \'Firma\' and {aufPersonTypID} notempty',
                title: {
                  default: 'Vorname:',
                  de: 'Vorname'
                },
                titleLocation: 'top'
              },
              {
                type: 'text',
                name: 'aufPersonGeburtstag',
                visibleIf: '{aufPersonAnredeID} <> \'Firma\' and {aufPersonTypID} notempty',
                startWithNewLine: false,
                title: {
                  default: 'Geburtstag:',
                  de: 'Geburtsdatum'
                },
                validators: [
                  {
                    type: 'regex',
                    text: 'Bitte geben Sie ein gültiges Datum an!',
                    regex: '^(19|20){1}[0-9]{2}-.*'
                  }
                ],
                titleLocation: 'top',
                inputType: 'date'
              },
              {
                type: 'text',
                name: 'aufPersonStrasse',
                visibleIf: '{aufPersonTypID} notempty',
                title: {
                  default: 'Strasse:',
                  de: 'Strasse'
                },
                titleLocation: 'top'
              },
              {
                type: 'text',
                name: 'aufPersonPlz',
                visibleIf: '{aufPersonTypID} notempty',
                startWithNewLine: false,
                title: {
                  default: 'Plz:',
                  de: 'Plz'
                },
                titleLocation: 'top'
              },
              {
                type: 'text',
                name: 'aufPersonOrt',
                visibleIf: '{aufPersonTypID} notempty',
                title: {
                  default: 'Ort:',
                  de: 'Ort'
                },
                titleLocation: 'top'
              },
              {
                type: 'dropdown',
                name: 'aufPersonLkz',
                visibleIf: '{aufPersonTypID} notempty',
                startWithNewLine: false,
                title: {
                  de: 'Land'
                },
                defaultValue: 'AT',
                titleLocation: 'top',
                choices: [
                  {
                    value: 'AL',
                    text: 'Albanien'
                  },
                  {
                    value: 'AD',
                    text: 'Andorra'
                  },
                  {
                    value: 'AO',
                    text: 'Angola'
                  },
                  {
                    value: 'BE',
                    text: 'Belgien'
                  },
                  {
                    value: 'BA',
                    text: 'Bosnien-Herzegowina'
                  },
                  {
                    value: 'BG',
                    text: 'Bulgarien'
                  },
                  {
                    value: 'DK',
                    text: 'Dänemark'
                  },
                  {
                    value: 'DE',
                    text: 'Deutschland'
                  },
                  {
                    value: 'EE',
                    text: 'Estland'
                  },
                  {
                    value: 'FI',
                    text: 'Finnland'
                  },
                  {
                    value: 'FR',
                    text: 'Frankreich'
                  },
                  {
                    value: 'GE',
                    text: 'Georgien'
                  },
                  {
                    value: 'GR',
                    text: 'Griechenland'
                  },
                  {
                    value: 'GB',
                    text: 'Großbritannien'
                  },
                  {
                    value: 'IE',
                    text: 'Irland'
                  },
                  {
                    value: 'IS',
                    text: 'Island'
                  },
                  {
                    value: 'IT',
                    text: 'Italien'
                  },
                  {
                    value: 'YU',
                    text: 'Jugoslawien'
                  },
                  {
                    value: 'HR',
                    text: 'Kroatien'
                  },
                  {
                    value: 'LV',
                    text: 'Litauen'
                  },
                  {
                    value: 'LU',
                    text: 'Luxemburg'
                  },
                  {
                    value: 'MT',
                    text: 'Malta'
                  },
                  {
                    value: 'MK',
                    text: 'Mazedonien'
                  },
                  {
                    value: 'MD',
                    text: 'Moldawien'
                  },
                  {
                    value: 'MC',
                    text: 'Monaco'
                  },
                  {
                    value: 'NL',
                    text: 'Niederlande'
                  },
                  {
                    value: 'NO',
                    text: 'Norwegen'
                  },
                  {
                    value: 'AT',
                    text: 'Österreich'
                  },
                  {
                    value: 'PL',
                    text: 'Polen'
                  },
                  {
                    value: 'PT',
                    text: 'Portugal'
                  },
                  {
                    value: 'RO',
                    text: 'Rumänien'
                  },
                  {
                    value: 'RU',
                    text: 'Russland '
                  },
                  {
                    value: 'SE',
                    text: 'Schweden'
                  },
                  {
                    value: 'CH',
                    text: 'Schweiz'
                  },
                  {
                    value: 'SK',
                    text: 'Slowakei'
                  },
                  {
                    value: 'SI',
                    text: 'Slowenien'
                  },
                  {
                    value: 'ES',
                    text: 'Spanien'
                  },
                  {
                    value: 'CZ',
                    text: 'Tschechische Rep.'
                  },
                  {
                    value: 'TR',
                    text: 'Türkei'
                  },
                  {
                    value: 'UA',
                    text: 'Ukraine'
                  },
                  {
                    value: 'HU',
                    text: 'Ungarn'
                  },
                  {
                    value: 'BY',
                    text: 'Weissrussland'
                  },
                  {
                    value: 'CY',
                    text: 'Zypern'
                  }
                ],
                optionsCaption: {
                  de: '-Bitte Auswählen-'
                }
              },
              {
                type: 'text',
                name: 'aufPersonTelefon',
                visibleIf: '{aufPersonTypID} notempty',
                title: {
                  default: 'Telefon:',
                  de: 'Telefon'
                },
                titleLocation: 'top'
              },
              {
                type: 'text',
                name: 'aufPersonMobiltelefon',
                visibleIf: '{aufPersonTypID} notempty',
                startWithNewLine: false,
                title: {
                  default: 'Mobiltelefon:',
                  de: 'Mobiltelefon'
                },
                titleLocation: 'top'
              },
              {
                type: 'text',
                name: 'aufPersonMail',
                visibleIf: '{aufPersonTypID} notempty',
                startWithNewLine: false,
                title: {
                  de: 'E-Mail'
                },
                validators: [
                  {
                    type: 'email',
                    text: 'Bitte geben Sie eine gültige E-Mail Adresse an.'
                  }
                ],
                titleLocation: 'top'
              }
            ],
            title: 'Weitere Vertragspersonen'
          },
          {
            type: 'panel',
            name: 'panel2',
            elements: [
              {
                type: 'dropdown',
                name: 'aufVertragsobjektTypID',
                title: {
                  de: 'Objekttyp'
                },
                commentText: {
                  de: 'C'
                },
                isRequired: true,
                requiredErrorText: {
                  de: 'Bitte füllen Sie dieses Feld aus!'
                },
                titleLocation: 'top',
                choices: [
                  {
                    value: 'Anhänger / Wohnanhänger',
                    text: 'Anhänger / Wohnanhänger'
                  },
                  {
                    value: 'Fahrzeuge bis 3,49t',
                    text: 'Fahrzeuge  bis 3,49t'
                  },
                  {
                    value: 'Fahrzeuge 3,5t bis 5,99t',
                    text: 'Fahrzeuge 3,5t bis 5,99t'
                  },
                  {
                    value: 'Fahrzeuge 6,0t bis 11,99t',
                    text: 'Fahrzeuge 6,0t bis 11,99t'
                  },
                  {
                    value: 'Fahrzeuge über 12t',
                    text: 'Fahrzeuge über 12t'
                  },
                  {
                    value: 'Landmaschine',
                    text: 'Landmaschine'
                  },
                  {
                    value: 'Motorrad / Trike',
                    text: 'Motorrad / Trike'
                  },
                  {
                    value: 'Nutzfahrzeug',
                    text: 'Nutzfahrzeug'
                  },
                  {
                    value: 'Quad',
                    text: 'Quad'
                  },
                  {
                    value: 'Wohnwagen',
                    text: 'Wohnwagen'
                  },
                  {
                    value: 'Sonstiges',
                    text: 'Sonstiges'
                  }
                ],
                otherText: {
                  de: 'Sonstiges'
                },
                storeOthersAsComment: false,
                optionsCaption: {
                  de: 'Um was für ein Objekt handelt es sich?'
                }
              },
              {
                type: 'text',
                name: 'aufVertragsobjektBezeichnung',
                visible: false,
                visibleIf: '{aufVertragsobjektTypID} = \'Sonstiges\'',
                startWithNewLine: false,
                title: {
                  de: ' '
                },
                titleLocation: 'top',
                placeHolder: {
                  de: 'Bei Sonstiges bitte hier Eintragen'
                }
              },
              {
                type: 'dropdown',
                name: 'aufVertragsobjektHerstellerID',
                title: {
                  de: 'Hersteller'
                },
                commentText: {
                  de: 'Bei Sonstiges bitte hier Eintragen'
                },
                isRequired: true,
                requiredErrorText: {
                  de: 'Bitte füllen Sie dieses Feld aus!'
                },
                titleLocation: 'top',
                choices: [
                  'Alfa Romeo',
                  'Audi',
                  'BMW',
                  'Chevrolet',
                  'Chrysler',
                  'Citroen',
                  'Dacia',
                  'Daewoo',
                  'Daihatsu',
                  'Dodge',
                  'Ducati',
                  'Fiat',
                  'Ford',
                  'Harley-Davidson',
                  'Honda',
                  'Hyundai',
                  'IVECO',
                  'Jaguar',
                  'Jeep',
                  'John Deere',
                  'Kawasaki',
                  'Kia',
                  'Lancia',
                  'Land Rover',
                  'Lexus',
                  'MAN',
                  'Maserati',
                  'Mazda',
                  'Mercedes-Benz',
                  'MINI',
                  'Mitsubishi',
                  'Nissan',
                  'Opel',
                  'Peugeot',
                  'Porsche',
                  'Renault',
                  'Rover',
                  'Saab',
                  'Seat',
                  'Skoda',
                  'Smart',
                  'SsangYong',
                  'Subaru',
                  'Suzuki',
                  'Toyota',
                  'Volvo',
                  'Volkswagen',
                  'Yamaha',
                  'Sonstige'
                ],
                optionsCaption: {
                  de: '-Bitte Auswählen-'
                }
              },
              {
                type: 'text',
                name: 'aufVertragsobjektModell',
                startWithNewLine: false,
                title: {
                  default: 'Modell:',
                  de: 'Modell'
                },
                isRequired: true,
                requiredErrorText: {
                  de: 'Bitte füllen Sie dieses Feld aus!'
                },
                titleLocation: 'top'
              },
              {
                type: 'text',
                name: 'aufVertragsobjektIdent',
                startWithNewLine: false,
                title: {
                  default: 'Ident.-Nummer/FIN:',
                  de: 'Identnr./FIN'
                },
                isRequired: true,
                requiredErrorText: {
                  de: 'Bitte füllen Sie dieses Feld aus!'
                },
                titleLocation: 'top'
              },
              {
                type: 'text',
                name: 'aufVertragsobjektKennzeichen',
                startWithNewLine: false,
                title: {
                  default: 'Kennzeichen:',
                  de: 'Kennzeichen'
                },
                titleLocation: 'top'
              },
              {
                type: 'comment',
                name: 'aufVertragsobjektBemerkung',
                title: {
                  default: 'Besondere Hinweise zum Auftrag:',
                  de: 'Bemerkung / Besonderheit zum Vertragsobjekt'
                },
                titleLocation: 'top',
                rows: 3,
                placeHolder: {
                  de: 'z.B. nicht mehr zugelassen, verunfallt, usw.'
                }
              }
            ],
            title: 'Vertragsobjekt'
          },
          {
            type: 'panel',
            name: 'panel3',
            elements: [
              {
                type: 'text',
                name: 'aufForderungDatum',
                title: {
                  default: 'Forderungsdatum:',
                  de: 'Fälligkeitsdatum der Hauptforderung / Rückstand (exklusive Zinsen und Kosten)'
                },
                validators: [
                  {
                    type: 'regex',
                    text: 'Bitte geben Sie ein gültiges Datum an!',
                    regex: '^(19|20){1}[0-9]{2}-.*'
                  }
                ],
                titleLocation: 'top',
                inputType: 'date',
                placeHolder: {
                  de: 'Wann ist die Forderung bei ihnen entstanden?'
                }
              },
              {
                type: 'dropdown',
                name: 'aufForderungWaehrungID',
                startWithNewLine: false,
                title: {
                  de: 'Währung'
                },
                defaultValue: '1',
                readOnly: true,
                titleLocation: 'top',
                choices: [
                  {
                    value: '1',
                    text: {
                      de: 'EUR'
                    }
                  },
                  {
                    value: '2',
                    text: {
                      de: 'CHF'
                    }
                  },
                  {
                    value: '3',
                    text: {
                      de: 'DKK'
                    }
                  },
                  {
                    value: '5',
                    text: {
                      de: 'SKR'
                    }
                  }
                ],
                optionsCaption: {
                  de: '-Bitte Auswählen-'
                }
              },
              {
                type: 'text',
                name: 'aufForderungRueckstand',
                title: {
                  default: 'Akt. Rückstand:',
                  de: 'Aktuelle Hauptforderung / Rückstand'
                },
                validators: [
                  {
                    type: 'regex',
                    text: 'Bitte geben Sie einen gültigen Betrag mit zwei Nachkommastellen an.',
                    regex: '^(0{1}|((0){1}\\,([0-9]{2}))|([1-9]{1}[0-9]*)|([1-9]{1}([0-9]*)\\,([0-9]{2})))$'
                  }
                ],
                titleLocation: 'top',
                placeHolder: {
                  de: 'ohne Kosten und Zinsen'
                }
              },
              {
                type: 'text',
                name: 'aufForderungGebuehr',
                startWithNewLine: false,
                title: {
                  default: 'Gebühren:',
                  de: 'Rücklastschriftgebühr'
                },
                validators: [
                  {
                    type: 'regex',
                    text: 'Bitte geben Sie einen gültigen Betrag mit zwei Nachkommastellen an.',
                    regex: '^(0{1}|((0){1}\\,([0-9]{2}))|([1-9]{1}[0-9]*)|([1-9]{1}([0-9]*)\\,([0-9]{2})))$'
                  }
                ],
                titleLocation: 'top'
              },
              {
                type: 'text',
                name: 'aufForderungKosten',
                title: {
                  default: 'Kosten:',
                  de: 'Mahnkosten'
                },
                validators: [
                  {
                    type: 'regex',
                    text: 'Bitte geben Sie einen gültigen Betrag mit zwei Nachkommastellen an.',
                    regex: '^(0{1}|((0){1}\\,([0-9]{2}))|([1-9]{1}[0-9]*)|([1-9]{1}([0-9]*)\\,([0-9]{2})))$'
                  }
                ],
                titleLocation: 'top'
              },
              {
                type: 'text',
                name: 'aufForderungSonstigeKosten',
                startWithNewLine: false,
                title: {
                  default: 'Kosten:',
                  de: 'Sonstige Kosten'
                },
                validators: [
                  {
                    type: 'regex',
                    text: 'Bitte geben Sie einen gültigen Betrag mit zwei Nachkommastellen an.',
                    regex: '^(0{1}|((0){1}\\,([0-9]{2}))|([1-9]{1}[0-9]*)|([1-9]{1}([0-9]*)\\,([0-9]{2})))$'
                  }
                ],
                titleLocation: 'top'
              },
              {
                type: 'text',
                name: 'aufForderungRateBetrag',
                title: {
                  default: 'Ratenhöhe:',
                  de: 'Monatliche Ratenhöhe'
                },
                validators: [
                  {
                    type: 'regex',
                    text: 'Bitte geben Sie einen gültigen Betrag mit zwei Nachkommastellen an.',
                    regex: '^(0{1}|((0){1}\\,([0-9]{2}))|([1-9]{1}[0-9]*)|([1-9]{1}([0-9]*)\\,([0-9]{2})))$'
                  }
                ],
                titleLocation: 'top'
              },
              {
                type: 'text',
                name: 'aufForderungRateDatum',
                startWithNewLine: false,
                title: {
                  default: 'nächste Rate:',
                  de: 'nächste Ratenfälligkeit'
                },
                validators: [
                  {
                    type: 'regex',
                    text: 'Bitte geben Sie ein gültiges Datum an!',
                    regex: '^(19|20){1}[0-9]{2}-.*'
                  }
                ],
                titleLocation: 'top',
                inputType: 'date'
              }
            ],
            title: 'Forderungsinformation',
            description: {
              de: 'Informationen zu der bei Ihnen enstandenen Forderung'
            }
          },
          {
            type: 'panel',
            name: 'panel4',
            elements: [
              {
                type: 'text',
                name: 'aufEinstellortName',
                title: {
                  default: 'Name:',
                  de: 'Name'
                },
                titleLocation: 'top'
              },
              {
                type: 'text',
                name: 'aufEinstellortTelefon',
                startWithNewLine: false,
                title: {
                  default: 'Telefon:',
                  de: 'Telefon'
                },
                titleLocation: 'top'
              },
              {
                type: 'text',
                name: 'aufEinstellortStrasse',
                title: {
                  default: 'Strasse:',
                  de: 'Strasse'
                },
                titleLocation: 'top'
              },
              {
                type: 'text',
                name: 'aufEinstellortPlz',
                startWithNewLine: false,
                title: {
                  default: 'Plz:',
                  de: 'Plz'
                },
                titleLocation: 'top'
              },
              {
                type: 'text',
                name: 'aufEinstellortOrt',
                title: {
                  default: 'Ort:',
                  de: 'Ort'
                },
                titleLocation: 'top'
              },
              {
                type: 'dropdown',
                name: 'aufEinstellortLkz',
                startWithNewLine: false,
                title: {
                  de: 'Land'
                },
                defaultValue: 'AT',
                titleLocation: 'top',
                choices: [
                  {
                    value: 'AL',
                    text: 'Albanien'
                  },
                  {
                    value: 'AD',
                    text: 'Andorra'
                  },
                  {
                    value: 'AO',
                    text: 'Angola'
                  },
                  {
                    value: 'BE',
                    text: 'Belgien'
                  },
                  {
                    value: 'BA',
                    text: 'Bosnien-Herzegowina'
                  },
                  {
                    value: 'BG',
                    text: 'Bulgarien'
                  },
                  {
                    value: 'DK',
                    text: 'Dänemark'
                  },
                  {
                    value: 'DE',
                    text: 'Deutschland'
                  },
                  {
                    value: 'EE',
                    text: 'Estland'
                  },
                  {
                    value: 'FI',
                    text: 'Finnland'
                  },
                  {
                    value: 'FR',
                    text: 'Frankreich'
                  },
                  {
                    value: 'GE',
                    text: 'Georgien'
                  },
                  {
                    value: 'GR',
                    text: 'Griechenland'
                  },
                  {
                    value: 'GB',
                    text: 'Großbritannien'
                  },
                  {
                    value: 'IE',
                    text: 'Irland'
                  },
                  {
                    value: 'IS',
                    text: 'Island'
                  },
                  {
                    value: 'IT',
                    text: 'Italien'
                  },
                  {
                    value: 'YU',
                    text: 'Jugoslawien'
                  },
                  {
                    value: 'HR',
                    text: 'Kroatien'
                  },
                  {
                    value: 'LV',
                    text: 'Litauen'
                  },
                  {
                    value: 'LU',
                    text: 'Luxemburg'
                  },
                  {
                    value: 'MT',
                    text: 'Malta'
                  },
                  {
                    value: 'MK',
                    text: 'Mazedonien'
                  },
                  {
                    value: 'MD',
                    text: 'Moldawien'
                  },
                  {
                    value: 'MC',
                    text: 'Monaco'
                  },
                  {
                    value: 'NL',
                    text: 'Niederlande'
                  },
                  {
                    value: 'NO',
                    text: 'Norwegen'
                  },
                  {
                    value: 'AT',
                    text: 'Österreich'
                  },
                  {
                    value: 'PL',
                    text: 'Polen'
                  },
                  {
                    value: 'PT',
                    text: 'Portugal'
                  },
                  {
                    value: 'RO',
                    text: 'Rumänien'
                  },
                  {
                    value: 'RU',
                    text: 'Russland '
                  },
                  {
                    value: 'SE',
                    text: 'Schweden'
                  },
                  {
                    value: 'CH',
                    text: 'Schweiz'
                  },
                  {
                    value: 'SK',
                    text: 'Slowakei'
                  },
                  {
                    value: 'SI',
                    text: 'Slowenien'
                  },
                  {
                    value: 'ES',
                    text: 'Spanien'
                  },
                  {
                    value: 'CZ',
                    text: 'Tschechische Rep.'
                  },
                  {
                    value: 'TR',
                    text: 'Türkei'
                  },
                  {
                    value: 'UA',
                    text: 'Ukraine'
                  },
                  {
                    value: 'HU',
                    text: 'Ungarn'
                  },
                  {
                    value: 'BY',
                    text: 'Weissrussland'
                  },
                  {
                    value: 'CY',
                    text: 'Zypern'
                  }
                ],
                optionsCaption: {
                  de: '-Bitte Auswählen-'
                }
              }
            ],
            title: 'Einstellort',
            description: {
              de: 'Wohin soll das Vertragsobjekt nach Sicherstellung verbracht werden?'
            }
          },
          {
            type: 'panel',
            name: 'panel7',
            elements: [
              {
                type: 'comment',
                name: 'aufBemerkung',
                title: {
                  default: 'Besondere Hinweise zum Auftrag:',
                  de: 'Gibt es etwas zu beachten?'
                },
                titleLocation: 'top',
                rows: 3
              }
            ],
            title: {
              de: 'Besondere Hinweise zum Auftrag'
            }
          },
          {
            type: 'checkbox',
            name: 'aufEingabeueberpruefung',
            title: {
              de: ' Eingabeüberprüfung'
            },
            isRequired: true,
            requiredErrorText: {
              de: 'Bitte füllen Sie dieses Feld aus!'
            },
            titleLocation: 'top',
            choices: [
              {
                value: 'positiv',
                text: {
                  de: 'Sind Sie sicher das alle Ihre Angaben der Richtigkeit und Vollständigkeit entsprechen?'
                }
              }
            ]
          }
        ]
      }
    ],
    showPrevButton: false,
    showQuestionNumbers: 'off',
    questionTitleLocation: 'left',
    questionErrorLocation: 'bottom',
    requiredText: '(*)'
  };
  data: any = {
    Auftragsranmendaten: {
      Mandant: 'Banque PSA Finance Niederlassung Österreich',
      Ansprechpartner: '',
      Auftragsziel: '',
      Vertragsart: '',
      Vertragsnummer: null,
      Vertragsdatum: null
    },
    Kundendaten: {
      Anrede: '',
      Name: null,
      Vorname: null,
      Geburtsdatum: null,
      Strasse: null,
      Plz: null,
      Ort: null,
      Land: '',
      Telefon: null,
      Mobiltelefon: null,
      EMail: null
    },
    WeitereVertragspersonen: {
      Rolle: '',
      Anrede: '',
      Name: null,
      Vorname: null,
      Geburtsdatum: null,
      Strasse: null,
      Plz: null,
      Ort: null,
      Land: '',
      Telefon: null,
      Mobiltelefon: null,
      EMail: null
    },
    Vertragsobject: {
      Objekttyp: '',
      Sonstiges: null,
      Hersteller: '',
      Modell: null,
      IdentnrFin: null,
      Kennzeichen: null,
      Bemerkungen: null
    },
    Forderungsinformation: {
      Faelligkeitsdatum: null,
      Waehrung: '1',
      AktuelleHauptforderung: null,
      Ruecklastschrift: null,
      Mahnkosten: null,
      SonstigeKosten: null,
      MonatlicheRate: null,
      NaechsteFaelligkeit: null
    },
    Einstellort: {
      Name: null,
      Telefon: 'EUR',
      Strasse: null,
      Plz: null,
      Ort: null,
      Land: ''
    },
    BesondereHinweise: {
      Kommentar: null,
      Eingabepruefung: false
    }
  };
  dataOriginal: any = {

    auf_OE_ID: '633',
    mdtAnsprechpartnerId: '',
    aufZielID: '',
    aufArtID: '',
    aufVertragsnr: null,
    aufVertragsdatum: null,

    aufKundeAnredeID: '',
    aufKundeName: null,
    aufKundeVorname: null,
    aufKundeGeburtstag: null,
    aufKundeStrasse: null,
    aufKundePlz: null,
    aufKundeOrt: null,
    aufKundeLkz: 'AT',
    aufKundeTelefon: null,
    aufKundeMobiltelefon: null,
    aufKundeMail: null,

    aufPersonTypID: '',
    aufPersonAnredeID: '',
    aufPersonName: null,
    aufPersonVorname: null,
    aufPersonGeburtstag: null,
    aufPersonStrasse: null,
    aufPersonPlz: null,
    aufPersonOrt: null,
    aufPersonLkz: 'AT',
    aufPersonTelefon: null,
    aufPersonMobiltelefon: null,
    aufPersonMail: null,

    aufVertragsobjektTypID: '',
    aufVertragsobjektBezeichnung: null,
    aufVertragsobjektHerstellerID: '',
    aufVertragsobjektModell: null,
    aufVertragsobjektIdent: null,
    aufVertragsobjektKennzeichen: null,
    aufVertragsobjektBemerkung: null,

    aufForderungDatum: null,
    aufForderungWaehrungID: '1',
    aufForderungRueckstand: null,
    aufForderungGebuehr: null,
    aufForderungKosten: null,
    aufForderungSonstigeKosten: null,
    aufForderungRateBetrag: null,
    aufForderungRateDatum: null,

    aufEinstellortName: null,
    aufEinstellortTelefon: null,
    aufEinstellortStrasse: null,
    aufEinstellortPlz: null,
    aufEinstellortOrt: null,
    aufEinstellortLkz: 'AT',

    aufBemerkung: null,
    aufEingabeueberpruefung: false
  };
  ansprechpartnerOptions = [
    {
      value: 'Burian, Werner',
      text: 'Burian, Werner'
    },
    {
      value: 'Dresler, Lothar-Philipp',
      text: 'Dresler, Lothar-Philipp'
    },
    {
      value: 'Kotalik, Susanne',
      text: 'Kotalik, Susanne'
    },
    {
      value: 'Krischek, Monika',
      text: 'Krischek, Monika'
    },
    {
      value: 'Legrand, Marie-Anne',
      text: 'Legrand, Marie-Anne'
    },
    {
      value: 'Mayer, Barbara',
      text: 'Mayer, Barbara'
    },
    {
      value: 'Schrefel, Tiffany',
      text: 'Schrefel, Tiffany'
    },
    {
      value: 'Schuh, Petra',
      text: 'Schuh, Petra'
    },
    {
      value: 'Zechner, Barbara',
      text: 'Zechner, Barbara'
    }
  ];
  auftragszielOptions = [
    'Forderungsausgleich',
    'Sicherstellung',
    'Forderungsausgleich oder Sicherstellung'
  ];
  weiterePersonOptions = [
    'Arbeitgeber',
    'Bürge',
    'Sonstige'
  ];
  vertragsartOptions = [
    'Kreditvertrag',
    'Leasingvertrag'
  ];
  anredeOptions = [
    'Herr',
    'Frau',
    'Firma'
  ];
  landOptions = [
    {
      value: 'AL',
      text: 'Albanien'
    },
    {
      value: 'AD',
      text: 'Andorra'
    },
    {
      value: 'AO',
      text: 'Angola'
    },
    {
      value: 'BE',
      text: 'Belgien'
    },
    {
      value: 'BA',
      text: 'Bosnien-Herzegowina'
    },
    {
      value: 'BG',
      text: 'Bulgarien'
    },
    {
      value: 'DK',
      text: 'Dänemark'
    },
    {
      value: 'DE',
      text: 'Deutschland'
    },
    {
      value: 'EE',
      text: 'Estland'
    },
    {
      value: 'FI',
      text: 'Finnland'
    },
    {
      value: 'FR',
      text: 'Frankreich'
    },
    {
      value: 'GE',
      text: 'Georgien'
    },
    {
      value: 'GR',
      text: 'Griechenland'
    },
    {
      value: 'GB',
      text: 'Großbritannien'
    },
    {
      value: 'IE',
      text: 'Irland'
    },
    {
      value: 'IS',
      text: 'Island'
    },
    {
      value: 'IT',
      text: 'Italien'
    },
    {
      value: 'YU',
      text: 'Jugoslawien'
    },
    {
      value: 'HR',
      text: 'Kroatien'
    },
    {
      value: 'LV',
      text: 'Litauen'
    },
    {
      value: 'LU',
      text: 'Luxemburg'
    },
    {
      value: 'MT',
      text: 'Malta'
    },
    {
      value: 'MK',
      text: 'Mazedonien'
    },
    {
      value: 'MD',
      text: 'Moldawien'
    },
    {
      value: 'MC',
      text: 'Monaco'
    },
    {
      value: 'NL',
      text: 'Niederlande'
    },
    {
      value: 'NO',
      text: 'Norwegen'
    },
    {
      value: 'AT',
      text: 'Österreich'
    },
    {
      value: 'PL',
      text: 'Polen'
    },
    {
      value: 'PT',
      text: 'Portugal'
    },
    {
      value: 'RO',
      text: 'Rumänien'
    },
    {
      value: 'RU',
      text: 'Russland '
    },
    {
      value: 'SE',
      text: 'Schweden'
    },
    {
      value: 'CH',
      text: 'Schweiz'
    },
    {
      value: 'SK',
      text: 'Slowakei'
    },
    {
      value: 'SI',
      text: 'Slowenien'
    },
    {
      value: 'ES',
      text: 'Spanien'
    },
    {
      value: 'CZ',
      text: 'Tschechische Rep.'
    },
    {
      value: 'TR',
      text: 'Türkei'
    },
    {
      value: 'UA',
      text: 'Ukraine'
    },
    {
      value: 'HU',
      text: 'Ungarn'
    },
    {
      value: 'BY',
      text: 'Weissrussland'
    },
    {
      value: 'CY',
      text: 'Zypern'
    }
  ];
  objektartOptions = [
    {
      value: 'Anhänger / Wohnanhänger',
      text: 'Anhänger / Wohnanhänger'
    },
    {
      value: 'Fahrzeuge bis 3,49t',
      text: 'Fahrzeuge  bis 3,49t'
    },
    {
      value: 'Fahrzeuge 3,5t bis 5,99t',
      text: 'Fahrzeuge 3,5t bis 5,99t'
    },
    {
      value: 'Fahrzeuge 6,0t bis 11,99t',
      text: 'Fahrzeuge 6,0t bis 11,99t'
    },
    {
      value: 'Fahrzeuge über 12t',
      text: 'Fahrzeuge über 12t'
    },
    {
      value: 'Landmaschine',
      text: 'Landmaschine'
    },
    {
      value: 'Motorrad / Trike',
      text: 'Motorrad / Trike'
    },
    {
      value: 'Nutzfahrzeug',
      text: 'Nutzfahrzeug'
    },
    {
      value: 'Quad',
      text: 'Quad'
    },
    {
      value: 'Wohnwagen',
      text: 'Wohnwagen'
    },
    {
      value: 'Sonstiges',
      text: 'Sonstiges'
    }
  ];
  herstellerOptions = [
    'Alfa Romeo',
    'Audi',
    'BMW',
    'Chevrolet',
    'Chrysler',
    'Citroen',
    'Dacia',
    'Daewoo',
    'Daihatsu',
    'Dodge',
    'Ducati',
    'Fiat',
    'Ford',
    'Harley-Davidson',
    'Honda',
    'Hyundai',
    'IVECO',
    'Jaguar',
    'Jeep',
    'John Deere',
    'Kawasaki',
    'Kia',
    'Lancia',
    'Land Rover',
    'Lexus',
    'MAN',
    'Maserati',
    'Mazda',
    'Mercedes-Benz',
    'MINI',
    'Mitsubishi',
    'Nissan',
    'Opel',
    'Peugeot',
    'Porsche',
    'Renault',
    'Rover',
    'Saab',
    'Seat',
    'Skoda',
    'Smart',
    'SsangYong',
    'Subaru',
    'Suzuki',
    'Toyota',
    'Volvo',
    'Volkswagen',
    'Yamaha',
    'Sonstige'
  ];
  waehrungOptions = [
    {
      value: '1',
      text: 'EUR'
    },
    {
      value: '2',
      text: 'CHF'
    },
    {
      value: '3',
      text: 'DKK'
    },
    {
      value: '5',
      text: 'SKR'
    }
  ];

  @ViewChild('hintCheckbox') hintCheckbox;

  constructor(private excRest: ExcRestService
              , private excLogin: ExcSigninService) {
  }
  handleCheckboxClick(event) {
    this.data.aufEingabeueberpruefung = this.hintCheckbox.value;
  }
  getData() {
    const x = {};
    for (const key of Object.keys(this.data)) {
      if (this.data[key] !== null && this.data[key] !== undefined && this.data[key] !== '') {
        if (key.toLowerCase().indexOf('datum') > -1) {
          const d = new Date(this.data[key]);
          x[key] = d.toISOString().substring(0, 10);
        } else {
          x[key] = this.data[key];
        }
      }
    }
    delete x['aufEingabeueberpruefung'];
    x['aufEingabeueberpruefung'] = [ (this.data['aufEingabeueberpruefung'] === true ? 'positiv' : 'negativ') ];
    x['aufUID'] = ExcCoreModule.Config().Environment.sec.user.faGuid;
    return x;
  }

  handleComplete() {
    const _self = this;
    const data = this.getData();
    _self.excRest.post(_self.excRest.computeUrl('OrderC', {}), data, {}).subscribe(ret => {
      if (ret) {
        window.scrollTo(0, 0);
        _self.data = {};
        Object.assign(_self.data, _self.dataOriginal);
        ExcCoreModule.showModal('Auftrag erfolgreich übermittelt.', 'Erfolg!', 's', {}, true);
      } else {
        ExcCoreModule.showModal('Auftragsdaten konnte nicht übermittelt werden.\r\nBitte versuchen Sie es erneut.', 'Achtung!', 's', {}, false);
      }
    }, error1 => {
      ExcCoreModule.showModal('Auftragsdaten konnte nicht übermittelt werden.\r\nBitte versuchen Sie es erneut.', 'Achtung!', 's', {}, false);
    });
  }

  ngOnInit() {
    this.data = {};
    Object.assign(this.data, this.dataOriginal);
  }
}
